import { api } from '@/api/core';
import {
  setCaseFilesAvailableDateBounds,
  setCaseFilesAvailableFilterOptions,
  setCaseFilesCategoryFilterOptions,
} from '@/store';
import {
  normalizeCaseFilesCategoryFilterOptions,
  type CaseFilesCategoryFilterOptionsFromApi,
} from '@/utils/caseFilesFilterSerialization';

export interface GetCaseFilesFilterOptionsRequest {
  caseId: string;
  userId: string;
}

export interface GetCaseFilesFilterOptionsResponse {
  minDate: string | null;
  maxDate: string | null;
  historyRowFilterOptions?: Record<string, string[]>;
  categoryFilterOptions?: CaseFilesCategoryFilterOptionsFromApi;
}

const getCaseFilesFilterOptionsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCaseFilesFilterOptions: builder.query<GetCaseFilesFilterOptionsResponse, GetCaseFilesFilterOptionsRequest>({
      query: ({ caseId, userId }) => ({
        url: '/matter/filter-options',
        method: 'GET',
        params: {
          user_id: userId,
          matter_id: caseId,
        },
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        const { data } = await queryFulfilled;
        dispatch(setCaseFilesAvailableFilterOptions(data.historyRowFilterOptions ?? {}));
        dispatch(
          setCaseFilesCategoryFilterOptions(normalizeCaseFilesCategoryFilterOptions(data.categoryFilterOptions)),
        );
        dispatch(setCaseFilesAvailableDateBounds({ minDate: data.minDate ?? null, maxDate: data.maxDate ?? null }));
      },
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useLazyGetCaseFilesFilterOptionsQuery } = getCaseFilesFilterOptionsApi;
